import type { QueryClient } from "@tanstack/react-query";
import { queryKeys } from "../services/queryKeys";
import { withMovedPositions } from "../services/storyCanvas/canvasItemMappers";
import type {
  CanvasItemListResponseApi,
  CanvasItemStubApi,
} from "../services/storyCanvas/storyCanvas.types";

/**
 * What the canvas write hooks do to the v2 loader's caches
 * (`useStoryCanvasApiV2`: the summary list and each item's read), beside what
 * they do to the v1 manifest's. A Story is drawn from one of the two, and a
 * cache nothing reads costs nothing to refresh, so the hooks do both.
 */

/** The summary list read again, and `itemId`'s own read when one is given. */
export const refreshStoryItems = (
  queryClient: QueryClient,
  storyId: string,
  itemId?: string,
): void => {
  queryClient.invalidateQueries({
    queryKey: queryKeys.storyItems.summaries(storyId),
    exact: true,
  });
  if (itemId === undefined) return;
  queryClient.invalidateQueries({
    queryKey: queryKeys.storyItems.detail(storyId, itemId),
    exact: true,
  });
};

/** The moved tiles' positions written into the summary list, with no refetch. */
export const placeStoryItems = (
  queryClient: QueryClient,
  storyId: string,
  moved: readonly CanvasItemStubApi[],
): void => {
  queryClient.setQueryData<CanvasItemListResponseApi>(
    queryKeys.storyItems.summaries(storyId),
    (previous) => previous && withMovedPositions(previous, moved),
  );
};
